import { ScaleAnswerTypeDto } from '@/api/generated';

import type { QuizQuestionsTranslations } from './quizQuestions.translation.pl.ts';

export const quizQuestionsTranslations: QuizQuestionsTranslations = {
  scaleQuestions: {
    scale3: {
      [ScaleAnswerTypeDto.Left]: 'A',
      [ScaleAnswerTypeDto.Center]: 'B',
      [ScaleAnswerTypeDto.Right]: 'C',
    },
    scale2: {
      [ScaleAnswerTypeDto.Left]: 'A',
      [ScaleAnswerTypeDto.Right]: 'B',
      [ScaleAnswerTypeDto.Center]: '',
    },
  },
  buttons: {
    next: 'Suivant',
    skip: 'Passer',
  },
  energyTable: {
    energyConsumption: "Consommation mensuelle moyenne d'énergie (kWh)",
    office: 'Bureau',
    renewableSources: "Sources d'énergie renouvelables (%)",
    warsaw: 'Varsovie',
  },
  questions: {
    1: {
      titles: {
        1: 'Oh… et ici, il se passe presque trop de choses.',
      },
      content: {
        1: "Tout le monde veut participer à la dernière mission interplanétaire vers Mars. Tu sais… le prestige, un projet incroyablement intéressant, et ces paysages… Un rêve ! Il n'y a pas beaucoup de places, et les volontaires ne manquent jamais. ",
        2: "Chaque mission exige des compétences pluridisciplinaires, et l'équipe doit compter un représentant de chaque département d'Orange.",
        3: 'Par exemple : dans le département des communications interplanétaires, nous avons deux candidats pour une seule place.',
        4: "Que faire ? Tu veux bien m'aider ? Comment régler cette situation - éviter les conflits et renforcer la coopération en même temps ?",
      },
    },
    2: {
      titles: {
        1: "Génial ! La première tâche est derrière toi ! Ce n'était pas si difficile, et tout ça sans l'aide de l'IA.",
      },
      content: {
        1: "Et puisqu'on parle d'intelligence artificielle, à ton époque déjà, on parlait beaucoup de responsabilité et des aspects éthiques du développement de l'IA. C'est tout aussi important aujourd'hui.",
        2: "Oh ! Je viens de me rappeler que j'ai quelque chose d'important à faire ! J'ai été invité à tester la version pilote d'un nouvel outil basé sur l'IA que tout le monde dans notre organisation utilisera bientôt. Ce sera un changement important pour l'entreprise, car il nous permettra de communiquer sous forme d'hologrammes et d'améliorer la collaboration entre les équipes. Si je décide de participer au pilote, je dois trouver du temps pour la formation initiale, les tests et les retours à l'équipe de déploiement. Et une journée n'a qu'un nombre d'heures limité...",
      },
    },
    3: {
      titles: {
        1: 'Merci pour le conseil ! Je vais faire comme ça !',
        2: "Nous apprécions la franchise et - comme chez Orange - nous nous appelons par nos prénoms, des prénoms d'humains.",
        3: "Mais trêve de plaisanteries. J'ai besoin de ton aide pour quelque chose. Tu vas y arriver, n'est-ce pas ?",
      },
      content: {
        1: "Pour te remercier, j'ai une blague pour toi.",
        2: `Deux robots se croisent dans la cuisine du bureau. <br/> L'un d'eux dit : <br/> - Salut, je suis Model-TRX-4987-Quantum-Unit-Alpha.<br/> - Oh, waouh ! – répond l'autre - Je peux t'appeler autrement ?<br/> - Bien sûr, appelle-moi simplement Chris.`,
        3: "Il y a un problème dans l'une des équipes. Certains robots font un excellent travail ;) D'autres se figent souvent - pas au sens propre, mais au sens figuré - et leur travail n'est plus aussi efficace. Les premières discussions avec l'équipe ont montré qu'il y a un souci de motivation, mais on ne sait pas exactement lequel. Comment pouvons-nous résoudre cette situation ?",
      },
    },
    4: {
      titles: {
        1: "Ça, c'est une idée ! Bon, il est temps de revenir sur Terre.",
      },
      content: {
        1: "Beaucoup de travail nous y attend. Le portail va s'ouvrir dans un instant. Quelle ironie - devoir attendre pour voyager dans le temps. Eh oui, que veux-tu - c'est l'air du… temps. Haha !",
        2: "À ton époque, le travail était un peu différent, non ? Beaucoup d'écriture à la main, d'analyses, de recherches... Pfiou, épuisant. </br> Mais chez Orange, vous aviez déjà quelque chose qui était une vraie révolution. Quelque chose que mes ancêtres numériques appelleraient un « game changer ». Je veux parler de Dinootoo. Ce n'était pas un programme ordinaire, mais une puissante plateforme d'intelligence artificielle générative accessible à chaque employé !",
        3: "Je savais que tu avais du flair pour la technologie ! Dinootoo était l'outil maison d'Orange - une porte d'accès sécurisée au savoir de l'époque. </br>Il donnait accès à plus d'une dizaine de LLM connus dans le monde entier, comme ChatGPT ou Gemini, mais dans un environnement d'entreprise sécurisé. Imagine : un seul assistant qui réunit les connaissances et les capacités de tous. Tu peux discuter avec lui, lui poser des questions ou lui envoyer des fichiers pour qu'il en extraie instantanément l'essentiel.</br>Mais ce n'est que la partie émergée de l'iceberg. Tu veux savoir de quelles tâches Dinootoo déchargeait concrètement les employés au quotidien ?",
        4: "Alors écoute bien, parce que ça ressemble à de la magie, et à ton époque c'était le quotidien ! Dinootoo était un maître des tâches fastidieuses. Besoin d'écrire un e-mail délicat en respectant les règles du langage clair ? Dinootoo s'en charge en quelques secondes. Besoin du résumé d'un long rapport ou des notes d'une réunion ? Hop - c'est fait. Ou peut-être t'entraîner à donner du feedback, structurer une présentation, générer des images, voire te faire aider pour écrire du code ? Pour Dinootoo, c'était un jeu d'enfant. Grâce à cela, les gens retrouvaient du temps pour ce qui compte le plus au travail - la créativité et le développement - au lieu de se noyer dans la routine. Mais il y avait encore une fonction super avancée qui permettait de « cloner » des assistants. Tu veux découvrir cette cerise sur le gâteau ?",
        5: "Ce super-pouvoir, c'était la possibilité de créer ses propres assistants. Dans Dinootoo, chacun pouvait concevoir un assistant dédié, programmé pour aider dans des tâches bien précises, puis... le partager avec les autres membres de l'équipe ! C'est comme créer un expert dans un domaine qui travaille pour tout le monde 24 h/24, 7 j/7. Ce sont des outils comme celui-ci qui rendaient le travail chez Orange plus léger, plus efficace et tout simplement... plus agréable. Vous utilisiez l'IA pour avoir plus de place pour l'humain.",
        6: 'Charmant, mais assez de voyages nostalgiques. Le portail est actif ! On saute !',
      },
    },
    5: {
      titles: {
        1: 'Oh, je vois que nous sommes tombés en chemin sur le légendaire Orange Warsaw Festival. On se fait une robo-danse ?',
      },
      content: {
        1: "Tu savais que l'industrie musicale utilise elle aussi des technologies de pointe ? Grâce à elles, nous pouvons vivre les événements culturels encore plus intensément. Pense par exemple à la réalité augmentée, pour laquelle le réseau 5G est idéal.",
        2: "En ce moment, les organisateurs se demandent comment appeler une nouvelle technologie qui sera utilisée pour la première fois au festival cette année. Cette technologie te permettra de ressentir la musique de tout ton corps ! Ça va être génial ! Seulement... comment pourrait-on l'appeler ?",
      },
    },
    6: {
      titles: {
        1: 'Bien ! Laissons les concerts aux stars, nous partons au bureau.',
      },
      content: {
        1: "Oh oh, on sent la tension ici. On dirait que quelqu'un vient de faire une blague déplacée.",
      },
    },
    7: {
      titles: {
        1: "Génial ! C'est bien d'avoir un humain compétent dans son équipe.",
      },
      content: {
        1: 'Et puisqu’on parle de compétences, dis-moi, comment les voit-on à ton époque ?',
      },
    },
    8: {
      titles: {
        1: "Tu entends ? C'est le son d'un concert ?",
      },
      content: {
        1: "En fait, on dirait les voix des organisateurs de l'Orange Warsaw Festival. Il ne reste que deux jours et encore tant à faire. Tu les aides à définir les priorités ?",
      },
    },
    9: {
      titles: {
        1: 'Et tout est au diapason ! Allons faire une promenade.',
      },
      content: {
        1: "Tu savais que grâce au travail d'Emilia et de son équipe, une belle forêt a poussé ici ? Elle a contribué à un autre objectif de l'entreprise : zéro émission nette.",
        2: "Planter des forêts n'est pas la seule chose que fait Orange pour prendre soin de l'environnement.",
      },
    },
    10: {
      titles: {
        1: "C'était une décision difficile, mais ta suggestion s'est révélée très utile. Merci !",
      },
      content: {
        1: "Mais Emilia a encore un dilemme - elle va commencer une réunion avec son équipe et doit lui annoncer le prochain plan d'action. Elle sait que c'est une bonne décision, mais elle est en même temps assez stressée, car ce sera sûrement un moment difficile pour eux.\nComment peut-elle gérer cela ?",
      },
    },
    11: {
      titles: {
        1: 'Ça a chauffé, mais nous y sommes arrivés ! La réunion commence. Maciek, notre collègue, va présenter les résultats de nos efforts jusqu’à présent.',
      },
      content: {
        1: "Oups ! Il s'est perdu dans l'interprétation des données, et maintenant il faut corriger ça. Tu nous aides ?",
        2: `Pendant sa présentation, Maciek a dit : « Hier, nous avons mené une enquête auprès de nos clients les plus fidèles pour savoir s'ils estiment que nos actions ont un impact significatif sur la lutte contre le changement climatique. Sur les 15 personnes qui ont participé à l'enquête, 12 ont confirmé notre hypothèse. Je pense que nous pouvons donc annoncer un grand succès pour cette initiative ! ».`,
      },
    },
    12: {
      titles: {
        1: 'Nous avons corrigé la présentation de Maciek. Place maintenant au final !',
      },
      content: {
        1: "L'une des actions que nous menons dans le cadre de notre objectif zéro émission nette consiste à réduire la quantité d'énergie issue de sources non renouvelables utilisée dans nos bureaux. ",
      },
    },
    13: {
      titles: {
        1: 'Génial ! Et nous voilà à la toute fin du défi !',
        2: 'Oh ? Serait-ce possible ? Oui ! Ça marche !',
      },
      content: {
        1: "C'est presque tout pour les tâches que je t'ai préparées. Il est temps de rentrer, le portail nous attend déjà.",
        2: "Ma cyber-boussole des valeurs fonctionne enfin correctement ! Tout ça grâce à ta façon d'agir et de prendre des décisions.",
        3: "Maintenant, je vois clairement que l'attention, c'est agir pour les clients, collaborer et respecter les autres. La responsabilité, c'est aller jusqu'au bout, communiquer de façon transparente et prendre soin de notre planète, et le courage, c'est chercher de nouvelles solutions.",
        4: "Il est maintenant temps pour toi de faire un pas audacieux vers l'avenir. J'espère que tu auras bientôt l'occasion de rejoindre nos stages. ",
        5: 'Pour finir, remplis un court formulaire.',
        6: "Je dois filer maintenant. J'ai été vraiment ravi de te rencontrer et j'espère… à bientôt ! Salut !",
      },
    },
  },
};
